import React from "react";

import type { ChildrenProps } from "../../../dom/types";

export const SumPathEffect = (props: ChildrenProps) => {
  return <skSumPathEffect {...props} />;
};
